// src/utils/formUtils.ts

export function normalizeSchema(schema: any[]): any[] {
  return schema.map(section => ({
    ...section,
    fields: section.field_definitions.map((f: any) => {
      if (typeof f === "string") {
        const field_label = f
          .replace(/_/g, " ")
          .replace(/\b\w/g, c => c.toUpperCase());
        return { field_name: f, field_label };
      }
      return f;
    }),
  }));
}

export function flattenFormData(formData: Record<string, any>): Record<string, any> {
  const flat: Record<string, any> = {};
  Object.values(formData || {}).forEach((group: any) => {
    Object.entries(group || {}).forEach(([fieldName, value]) => {
      flat[fieldName] = value;
    });
  });
  return flat;
}

export function extractServiceFee(obj: any): number {
  if (!obj) return 0;
  if (typeof obj === "object") {
    for (const key in obj) {
      if (key.toLowerCase() === "service_fee") {
        return Number(obj[key]) || 0;
      }
      const nested = extractServiceFee(obj[key]);
      if (nested) return nested;
    }
  }
  return 0;
}

/* -----------------------------------------------------
 * Collection Serialization
 * ---------------------------------------------------*/

// src/utils/formUtils.ts

export function normalizeData(
  mergedSchema: any[],
  existingData: Record<string, any>
) {
  const result: Record<string, any> = {};

  mergedSchema.forEach((section) => {
    const sectionName = section.section_name;

    if (section.is_collection) {
      // collections must ALWAYS be arrays
      const existingItems = Array.isArray(existingData?.[sectionName])
        ? existingData[sectionName]
        : [];

      result[sectionName] = existingItems.map((item: any) => {
        const normalizedItem: Record<string, any> = {};

        section.field_definitions.forEach((field: any) => {
          normalizedItem[field.field_name] =
            item?.[field.field_name] ??
            field.default_value ??
            "";
        });

        return normalizedItem;
      });

      return;
    }

    // non-collection section
    const sectionData = existingData?.[sectionName] ?? {};
    const normalizedSection: Record<string, any> = {};

    section.field_definitions.forEach((field: any) => {
      normalizedSection[field.field_name] =
        sectionData?.[field.field_name] ??
        field.default_value ??
        "";
    });

    result[sectionName] = normalizedSection;
  });

  return result;
}

export function normalizeFieldDefinitions(fieldDefSchema: any) {
  // Case A: already keyed by field name
  if (!fieldDefSchema) return {};

  if (!fieldDefSchema.properties && !fieldDefSchema.fields) {
    return fieldDefSchema;
  }

  const source =
    fieldDefSchema.properties ??
    fieldDefSchema.fields ??
    {};

  const result: Record<string, any> = {};

  Object.entries(source).forEach(([fieldName, schema]: any) => {
    result[fieldName] = {
      field_name: fieldName,
      ...schema, // 🔒 preserve EVERYTHING
    };
  });

  return result;
}
